import React, { useEffect, useState } from "react";

import styles from "./UserForm.module.css";

import request from "../../../utils/request";

import ModalQ from "../../../components/TableBionovaQ/ModalQ/ModalQ";
import {
  getDist,
  getSession,
  getUserId,
} from "../../../utils/sessionHandler";
import SelectQ from "../../../components/FormComponents/SelectQ/SelectQ";
import InputQ from "../../../components/FormComponents/InputQ/InputQ";
import ErrorMessage from "../../../components/TableBionovaQ/ErrorMessage/ErrorMessage";

const UserForm = ({
  formData,
  handleFormData,
  handleClose,
  open,
  locale,
  t,
  getUsers,
  sectors,
  userTypes,
  profiles,
  selectedSector,
}) => {
  const [error, setError] = useState("");
  const [validate, setValidate] = useState(false);
  const [loading, setLoading] = useState(false);

  const isAdmin = formData.userType === 0 && !!formData.id;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.name ||
      !formData.lastName ||
      (!formData.userType && !isAdmin) ||
      !formData.email
    ) {
      setValidate(true);
      return;
    } else {
      setValidate(false);
    }
    try {
      setLoading(true);

      let res;

      if (formData.id) {

        let newFormData = {...formData, userType: userTypes.find(ut => ut.value == formData.userType)?.name}
        
        res = await request().put("/api/appuser", {
          
          AppUser: newFormData,
          DistributorId: getDist().id,
          UserLogged: getSession(),
          moveToSaved: false,
        });
        if (formData.id === getUserId()) {
          let token = await request().get(
            `/api/UserScreenPermissions?AppUserId=${getUserId()}`
          );
          localStorage.setItem("permissions", token.data ?? null);
        }
      } else {
        res = await request().post("/api/appuser", {
          AppUser: formData,
          DistributorId: getDist().id,
          UserLogged: getSession(),
          moveToSaved: false,
        });
      }

      handleClose();
      setError("");
      setValidate(false);
      getUsers(selectedSector);

    } catch (err) {
      setError(err.response?.data?.message || "Error al guardar el usuario.")
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    handleFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSelectChange = (e) => {
    const { name, value } = e.target;
    handleFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const onClose = () => {
    handleClose();
    setError("");
    setValidate(false);
  };

  useEffect(() => {
    getUsers(selectedSector);
    formData.sectorId = selectedSector
  }, [selectedSector]);

  

  return (
    <ModalQ
      open={open}
      title={
        !formData.id
          ? t("NewUser", locale) || "New User"
          : t("EditUser", locale) || "Edit User"
      }
      handleClose={onClose}
      loading={loading}
    >
       {error && <ErrorMessage message={error} />}
      <div className={styles.container}>
        <div className={styles.inputGroup}>
          <SelectQ
            selectValue={formData.sectorId}
            handleSelect={handleSelectChange}
            containerWidth={"48%"}
            options={sectors}
            name={"sectorId"}
            label={t("sectorId", locale) || "Sector"}
            placeholder={t("sectorId", locale) || "Sector"}
            required={true}
            validate={validate}
            disabled={!formData.id}
            labelTop={true}
          />
          <InputQ
            containerWidth="48%"
            label={t("Email", locale) || "Email"}
            name="email"
            handleChange={handleInputChange}
            value={formData.email}
            required={true}
            validate={validate}
            labelTop={true}
            leftMessage={true}
            disabled={formData.id}
          />
        </div>
        <div className={styles.inputGroup}>
          <InputQ
            containerWidth="48%"
            label={t("NameSpan", locale) || "NameSpan"}
            name="name"
            handleChange={handleInputChange}
            value={formData.name}
            required={true}
            validate={validate}
            labelTop={true}
            leftMessage={true}
          />
          <InputQ
            containerWidth="48%"
            label={t("LastName", locale) || "Last Name"}
            name="lastName"
            handleChange={handleInputChange}
            value={formData.lastName}
            required={true}
            validate={validate}
            labelTop={true}
            leftMessage={true}
          />
        </div>
        <div className={styles.inputGroup}>
          <SelectQ
            selectValue={formData.userType}
            handleSelect={handleSelectChange}
            containerWidth={"48%"}
            options={userTypes}
            name={"userType"}
            label={t("userType", locale) || "User Type"}
            placeholder={
              isAdmin
                ? t("Administrator", locale) || "Administrator"
                : "No option"
            }
            hasPlaceholder={isAdmin}
            required={!isAdmin}
            validate={isAdmin ? validate : false}
            disabled={isAdmin}
            labelTop={true}
          />
          <SelectQ
            selectValue={formData.profileId}
            handleSelect={handleSelectChange}
            containerWidth={"48%"}
            options={profiles}
            name={"profileId"}
            label={t("ProfileSpan", locale) || "Profile"}
            placeholder={t("ProfileSpan", locale) || "Profile"}
            labelTop={true}
          />
        </div>
        <button
          className={`${styles.button} ${styles.confirmButton}`}
          onClick={(e) => handleSubmit(e)}
        >
          Confirm
        </button>
      </div>
    </ModalQ>
  );
};

export default UserForm;
